<script>
    import { currency_formatter } from '../../globals';
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import { api_host } from "../../stores.js";
    import { getToken, doFetch } from "../../utils/Fetching.js";
    import { toast_message } from '../../utils/toast_message.js';
    import { formatDate } from '../../utils/format.js';


    const { auth_type, auth_token, domain_code } = getToken();

    let content_title = "Reviewing Coupon";
    let cid = "";
    let coupon = {};
    let is_busy = false;

    onMount(async () => {
        const params = new URLSearchParams($querystring);
        console.log(params);
        if (params.has("cid")) {
            is_busy = true;
            cid = params.get("cid");
            console.log(cid);
            const res = await doFetch(
                `${api_host}/api/coupon/get/${cid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                coupon = res.coupon;
            }
            else { toast_message(false, res.msg || 'Fetching coupon failed', 3000); }
            is_busy = false;
        }
    });
</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="buttonholder">
        <button class="edit" on:click={() => { push("#/Coupon_Edit?cid=" + cid); }} >
            <i class="fas fa-edit"></i> Edit Coupon
        </button>
        <!-- <button class="delete"><i class="far fa-trash-alt"></i> Delete Coupon</button> -->
    </div>

    <div class="section couponinfo">
        <div class="sectiontitle"><i class="fas fa-tag"></i> Coupon Information</div>

        {#if Object.keys(coupon).length > 0}
        <div class="sectioninfo">
            <div class="column">
                <div class="infoitem">
                    <div class="infoitemtitle">Code:</div>
                    <div class="infoitemvalue">{coupon.code}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Description:</div>
                    <div class="infoitemvalue">{coupon.description}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Valid From:</div>
                    <div class="infoitemvalue">{formatDate(coupon.from_date)}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Valid To:</div>
                    <div class="infoitemvalue">{formatDate(coupon.to_date)}</div>
                </div>
            </div>

            <div class="column">
                <div class="infoitem">
                    <div class="infoitemtitle">Type:</div>
                    <div class="infoitemvalue strikeout">{coupon.value_type.includes('Maximum Amount') ? 'Maximum Amount $' : 'Percentage Discount %'}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Value:</div>
                    <div class="infoitemvalue">{coupon.value_type.includes('Maximum Amount') ? currency_formatter.format(coupon.value) : `${coupon.value.toFixed(2)}%`}</div>
                </div>

                <div class="infoitem">
                    <div class="infoitemtitle">Coupon Used:</div>
                    <div class="infoitemvalue">{coupon.coupon_used}</div>
                </div>
            </div>
        </div>
        {/if}
    </div>
</div>


<style>
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
                             "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "ri ri ri ri ri ri ri ri ri ri ri ri";
        gap: 20px;
    }
    .buttonholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        grid-area: bh;
    }
    .buttonholder button {
        width: 200px;
        margin-right: 20px;
        margin-top: 10px;
    }
    .buttonholder button.edit{
        background-color: #1c54b2;
        color: white;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 150px;
        font-weight: bold;
        text-align: right;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .column{
        display: flex;
        flex-direction: column;
    }
    .couponinfo {
        grid-area: ci;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "bh"
                                "ci"
                                "ri";
            gap: 20px;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button {
            width: 100%;
            /* text-align: left; */
        }
        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            width: 150px;
            font-weight: bold;
            text-align: right;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .column{
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
</style>